module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-05.56f7dba7.svg";